<template>
  <div>
    <div v-if="loading" class="flex loader-wrap">
      <Loader class="loader self-center w-full" :label="loadingLabel" />
    </div>

    <form v-if="!loading" @submit.prevent="onSubmit">
      <h3 class="mb-4 text-support">
        Login
      </h3>

      <div v-if="errors.length" class="error-box">
        <h4 class="error-title">
          Please correct the following error(s):
        </h4>
        <ul class="error-list">
          <li v-for="(error, index) in errors" :key="index">
            {{ error }}
          </li>
        </ul>
      </div>

      <div class="mb-4">
        <label for="shop" class="store-name-label">
          Your Store Name
        </label>
        <div class="input-group store-name-wrap">
          <Input
            v-model="shopName"
            class="w-full"
            input-class="rounded-r-none"
            name="shopName"
            placeholder="your-store-name"
            :disabled="loading"
          />
          <div class="input-group-append">
            <span class="input-group-text">
              .myshopify.com
            </span>
          </div>
        </div>

        <p class="info">Please don't include http:// in your store name</p>
      </div>

      <div class="flex justify-start mb-4">
        <Button
          class="secondary login-button"
          :disabled="loading"
          type="submit"
        >
          Sign in with Shopify
          <v-icon
            slot="icon-end"
            name="shopify"
            class="shopify-icon"
            scale="1.1"
          />
        </Button>
      </div>
    </form>
  </div>
</template>

<script>
import trim from "lodash.trim";

import { customAuth } from "@/lib/auth";

import Input from "@/components/UI/Input";
import Loader from "@/components/UI/Loader";
import { getAccountId } from "@/lib/auth";

export default {
  name: "ShopifyLogin",
  components: { Input, Loader },
  data: () => ({
    errors: [],
    loadingLabel: "Loading...",
    loading: false,
    shopName: "",
  }),
  mounted() {
    // Check for a challengeToken
    if (
      this.$has(this.$route, "query.challengeToken") &&
      this.$has(this.$route, "query.shopName")
    )
      this.initCustomAuth();
  },
  methods: {
    checkForm: function() {
      this.errors = [];

      if (!this.shopName) {
        this.errors.push("Store URL required.");
      }

      if (!this.errors.length) {
        return true;
      }
    },
    async initCustomAuth() {
      const { shopName } = this.$route.query;

      this.$emit("loading", true);
      this.loading = true;
      this.loadingLabel = "Authenticating with Shopify...";

      try {
        // Try and login
        await customAuth({
          shopName: trim(shopName),
          challengeToken: this.$route.query.challengeToken,
          apolloClient: this.$apollo.provider.defaultClient,
        });

        this.$gtm.trackEvent({
          event: "promo-login",
          accountId: getAccountId(),
          loginType: "shopify",
        });

        this.$emit("login-success");
        this.$emit("loading", false);
        this.loading = false;
      } catch (error) {
        this.errors.push(error);

        this.$emit("login-error");
        this.$emit("loading", false);
        this.loading = false;
      }
    },
    onSubmit: async function() {
      if (!this.checkForm()) return false;

      this.loadingLabel = "Redirecting to Shopify...";
      this.loading = true;
      this.$emit("loading", true);

      window.document.location.href = `${process.env.VUE_APP_SERVICES_URL}/shopify/auth?shop=${this.shopName}.myshopify.com`;
    },
  },
};
</script>

<style scoped>
.shopify-icon {
  @apply ml-1 relative;
  top: 2px;
}

.error-box {
  @apply border-2 border-danger rounded-lg px-4 py-2 mt-0 mb-4 text-danger-dark font-bold bg-danger-light;
}

.error-title {
  @apply leading-normal mb-2 font-light font-sans text-danger-dark;
}

.error-list {
  @apply leading-normal mb-0;
}

.loader-wrap {
  min-height: 175.7px;

  .loader {
    @apply mb-0;
  }
}

.info {
  @apply mb-0 text-grey-dark italic;
  font-size: 12px;
}

.login-button {
  @apply py-2 flex-1 justify-center rounded-lg;
  max-width: 233px;
}

.store-name-label {
  @apply mb-2;
}

.store-name-wrap {
  @apply mb-2 w-full;
  max-width: 422px;
}
</style>
